export const PERMISSION_BREADCRUMBS: Record<string, string> = {
  // latest features
  DUTY_MANAGEMENT_DUTY_DETAILS: 'user-role.breadcrumbs.duty',
  DUTY_MANAGEMENT:'user-role.breadcrumbs.duty',
  DUTY_PLANNING_ACTIVATION: 'user-role.breadcrumbs.duty',

  DUTY_DEPARTMENT_MAPPING: 'user-role.breadcrumbs.duty',

  // Holidays
  HOLIDAY_DETAILS: 'user-role.breadcrumbs.holidays',

  HOLIDAY_IMPORTED_DATA: 'user-role.breadcrumbs.holidays',

  // Staff/Team

  // Global Feature
  GLOBAL_DUTY_MANAGEMENT:'user-role.breadcrumbs.global-duty',

  GLOBAL_STAFF_BASIC_INFORMATION: 'user-role.breadcrumbs.global-staff',
  GLOBAL_STAFF_EMPLOYMENT_DETAILS: 'user-role.breadcrumbs.global-staff',
  GLOBAL_STAFF_CONFIGURATION_DETAILS: 'user-role.breadcrumbs.global-staff',

  // Non-global Feature
  STAFF_BASIC_INFORMATION: 'user-role.breadcrumbs.config-staff',
  STAFF_EMPLOYMENT_DETAILS: 'user-role.breadcrumbs.config-staff',
  STAFF_CONFIGURATION_DETAILS: 'user-role.breadcrumbs.config-staff',

  // Events
  EVENT_DETAILS: 'user-role.breadcrumbs.events',

  // Activities
  ACTIVITY_DETAILS: 'user-role.breadcrumbs.activities',

  // User Profile
  PROFILE_DETAILS: 'user-role.breadcrumbs.profile',

  // Dashboard staff allocation
  STAFF_ALLOCATION: 'user-role.breadcrumbs.dashboard',
  // Leave Summary
  LEAVE_DETAILS: 'user-role.breadcrumbs.dashboard', // View leave summary/status

  // Planning Sheet
  PLANNING_SHEET: 'user-role.breadcrumbs.planning-sheet',

  // Location Management
  LOCATION_DETAILS: 'user-role.breadcrumbs.location',

  // Organisation Management
  ORGANISATION_DETAILS: 'user-role.breadcrumbs.organisation',

  // Indicator Management
  INDICATOR_DETAILS: 'user-role.breadcrumbs.indicators',

  // Stream Management
  STREAM_MANAGEMENT: 'user-role.breadcrumbs.post',

  // Post Management
  POST_MANAGEMENT: 'user-role.breadcrumbs.post',
  
  //Permission for planning manager sheet
  MANAGER_PLANNING_SHEET: 'user-role.breadcrumbs.manager-planning',

  // Permission for planning sheet multidepartment view
  MULTIDEPARTMENT_PLANNING: 'user-role.breadcrumbs.multi-dept-planning',

//***************** PERMISSIONS FOR MOBILE****************
  // Time Difference management
  TIME_DIFFERENCE: 'user-role.breadcrumbs.mobile.time-diff',

  // leave request
  LEAVE_REQUEST:'user-role.breadcrumbs.mobile.leave',

  // wished duty
  DUTY_PREPLANNING:'user-role.breadcrumbs.mobile.preplan',
  
  // Swap request by user
  SWAP_REQUEST: 'user-role.breadcrumbs.mobile.swap-req', //Permission for user to view their swap request summary

  // profile management
  USER_PROFILE:'user-role.breadcrumbs.mobile.profile',

  // stream
  STREAM_DATA:'user-role.breadcrumbs.mobile.stream',
  
  // post
  POST_DATA:'user-role.breadcrumbs.mobile.stream',

  // duty allocation
  DUTY_ALLOCATION:'user-role.breadcrumbs.mobile.duty-alloc',
  // Chat management
  CHAT_DATA: 'user-role.breadcrumbs.mobile.chat',

  // For managing group level actions
  CHAT_GROUP_MANAGEMENT: 'user-role.breadcrumbs.mobile.chat',
  //Permission for PDF documents read/write in mobile app
  DOCUMENT_DATA: 'user-role.breadcrumbs.mobile.doc',

  //Permission for feedback read/write
  FEEDBACK_DATA: 'user-role.breadcrumbs.mobile.feedback',

};
